import studentHighlightsService from '../../services/StudentHighlightsService';
import timeReader from '../../store/readHelpers/TimeReader';
import uiService from '../../services/UIService';
import routeTypes from '../../constants/RouteTypes';
import remoteOralExamService from '../../services/RemoteOralExamService';
import utilService from '../../services/UtilService';
import assessmentReader from '../../store/readHelpers/AssessmentReader';
import questionReader from '../../store/readHelpers/QuestionReader';
import aclService from '../../services/AclService';
import marketplacePropertiesService from '../../services/MarketplacePropertiesService';

const ANNOTATION_SIDEBAR_STYLES = {
    visibleFixedWidth: { display: 'block', flexShrink: 0 },
    visible: { display: 'block' },
    hidden: { display: 'none' },
};

const appMainScreenSelector = {
    selectIsCurrentWordFormationQuestion(questionId) {
        if (!questionId) {
            return false;
        }

        const currentQuestion = assessmentReader.getQuestion(questionId);
        return !!currentQuestion && questionReader.isWordFormationQuestion(currentQuestion);
    },

    selectIsMarksOnlyAccess() {
        return aclService.validateCandidateSubmissionAccessLevel('marks_only');
    },

    selectIsQuestionsAndAnswersOnlyAccess() {
        return aclService.validateCandidateSubmissionAccessLevel('questions_answers_only');
    },

    selectAnnotationSidebarInlineStyles(showAnnotationsSidebar, isNotesPanelFixedWidthEnabled) {
        if (!showAnnotationsSidebar) {
            return ANNOTATION_SIDEBAR_STYLES.hidden;
        }
        return isNotesPanelFixedWidthEnabled
            ? ANNOTATION_SIDEBAR_STYLES.visibleFixedWidth
            : ANNOTATION_SIDEBAR_STYLES.visible;
    },

    selectProps(state) {
        const {
            assessment,
            currentlyShown: { routeType, questionId },
            remoteOralExam,
            session: { mode, viewMedia, context } } = state;
        const hasAssessment = utilService.isObjectWithProps(assessment);
        const showHeader = uiService.showHeader(routeType, mode, viewMedia, context);
        const timeHasExpired = timeReader.timeHasExpired();
        const showAnnotationsSidebar = uiService.showAnnotationsSidebar();
        const isNotesPanelFixedWidthEnabled = marketplacePropertiesService.isNotesPanelFixedWidthEnabled();

        return {
            addAppWrapper: routeType === routeTypes.ROUTE_TYPE_OPTIONS,
            isNoteTakingAndHighlightingEnabled: studentHighlightsService.isNoteTakingAndHighlightingEnabled(),
            isCurrentWordFormationQuestion: this.selectIsCurrentWordFormationQuestion(questionId),
            showAdditionalResourcesBar: uiService.showAdditionalResourcesBar(routeType, mode, viewMedia, context, timeHasExpired, hasAssessment),
            showAnnotationsSidebar,
            showChatSidebar: showHeader && uiService.showChatSidebar(),
            showFooter: uiService.showFooter(routeType, mode, viewMedia, context, timeHasExpired, hasAssessment),
            showHeader,
            showZoomCall: remoteOralExamService.showZoomCall(remoteOralExam, routeType),
            isMarksOnlyAccess: this.selectIsMarksOnlyAccess(),
            isNotesPanelFixedWidthEnabled,
            annotationSidebarInlineStyles: this.selectAnnotationSidebarInlineStyles(
                showAnnotationsSidebar,
                isNotesPanelFixedWidthEnabled,
            ),
        };
    },
};

export default appMainScreenSelector;
